import { useState } from 'react'
import { clsx } from 'clsx'

export default function ReasonPicker({ reasons, onChange }) {
  const [selected, setSelected] = useState(null)

  const pick = (r) => {
    setSelected(r)
    onChange(r)
  }

  return (
    <div className="flex flex-col gap-2">
      {reasons.map((r) => (
        <button
          key={r}
          onClick={() => pick(r)}
          className={clsx(
            'reason-option text-left',
            selected === r && 'reason-option-selected'
          )}
        >
          {r}
        </button>
      ))}
    </div>
  )
}
